export default __webpack_public_path__ + "static/media/nft4.f3fd85ec.png";